
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getWithAuthority } from '@/api/customer';
import { getDepartmentList } from '@/api/company';
import {
  addGroupCs,
  editGroupCs,
} from '@/api/group';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';

import DialogSelectCustomer from '@/components/CustomerDialog/levelByLevel.vue';

@Component({
  name: 'CustomerGroupsDialog',
  components: {
    DialogSelectCustomer
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogCustomerGroupsVisible!:Boolean;

  @Prop({
    type: String,
    default: '0'
  })
  isDefaultGroup!:String;

  @Prop({
    type: Object,
    default: () => {},
  })
  editorData!: any;

  private active = 0
  private pushId = ''
  // 客户选择
  private customerVisible = false;
  private editData: any = null;
  private isCheckbox = true;
  private selectCusromer: any = [];
  // 选择部门/人员
  private radioDeptStaff = '11';
  private dataTableDept:any = [];
  private formDeptDept = {
    name: ''
  };
  private multipleDeptSelection: any = [];
  private deptMore = false;
  private deptMoreLoading = false;
  private deptPage = 1;
  private deptSelectedAll= false; // 全选中
  private isDeptIndeterminate= false; // 全选框 模糊状态
  private selectDeptId:any=[]

  private dataTableStaff:any = [];
  private formDeptStaff = {
    name: '',
    phone: ''
  };
  private multipleUserSelection: any = [];
  private selectUserId:any=[]
  private userSelectedAll= false; // 全选中
  private isIndeterminate= false; // 全选框 模糊状态
  private userMore = false;
  private userMoreLoading = false;
  private userPage = 1;

  created() {
    if (this.editorData.id) {
      this.pushId = this.editorData.id;
    }
  }

  private closeSelectCustomerHandle() {
    this.active = 0; // 取消回到第一步
    this.selectCusromer = [];
    this.editData = {};
    this.customerVisible = false;
  }
  private selectCustomerHandle(value: any) { // 选完客户 该下一步
    this.active = 2;
    if (this.editData && this.editData.push_type) {
      if (parseInt(this.editData.push_type) === 11) {
        this.radioDeptStaff = '11'; // 人员
        this.multipleUserSelection = this.editData.userList;
        this.multipleDeptSelection = [];
      } else {
        this.radioDeptStaff = '10'; // 部门
        this.multipleDeptSelection = this.editData.deptList;
        this.multipleUserSelection = [];
      }
    }
    this.selectCusromer = value;
    // this.dialogSelectDeptStaffVisible = true;
    this.deptPage = 1;
    this.userPage = 1;
    this.getUserList();
    this.getDepartmentList();
  }

  // 选择部门/人员
  private deptMoreClick() {
    this.deptPage++;
    this.getDepartmentList();
  }
  private serchDept() {
    this.deptPage = 1;
    this.getDepartmentList();
  }
  private cleanSerchDept() {
    this.formDeptDept = { name: '' };
    this.deptPage = 1;
    this.getDepartmentList();
  }
  private getDepartmentList() {
    const params: any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      type: '9', // type=9 查所有部门  type=2查服务部门
      size: 10,
      page: this.deptPage
    };
    if (this.formDeptDept.name) {
      params.name = this.formDeptDept.name;
    }
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          if (this.deptPage === 1) {
            this.dataTableDept = res.data.list;
          } else {
            this.dataTableDept = this.dataTableDept.concat(...res.data.list);
          }
          if (this.deptPage < res.data.page_count) {
            this.deptMore = true;
          } else {
            this.deptMore = false;
          }
        } else {
          this.dataTableDept = [];
        }
        this.paseData(this.dataTableDept);
      })
      .catch((err) => {
        let msg = err.msg;
        this.dataTableDept = [];
        this.deptPage = 1;
      });
  }
  private paseData(val: any) {
    for (let i = 0; i < val.length; i++) {
      let cont: any = val[i];
      cont.area =
        val[i].province_name + val[i].city_name + val[i].district_name;
      cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(this.dataTableDept, cont, i);
    }
    let that = this;
    this.$nextTick(function() {
      if (that.multipleDeptSelection && that.multipleDeptSelection.length > 0) {
        that.multipleDeptSelection.forEach((ser:any) => {
          let have:any = [];
          if (that.dataTableStaff) {
            have = that.dataTableDept.filter((v:any) => {
              return v.id === ser.id;
            });
          }
          if (have && have.length > 0) {
            that.selectDeptId.push(have[0].id);
          }
        });
      }
    });
  }
  private deptSelectedAllchange() {
    if (this.deptSelectedAll) {
      // 全选
      for (let i = 0; i < this.dataTableDept.length; i++) {
        let index = this.selectDeptId.indexOf(this.dataTableDept[i].id);
        if (index === -1) {
          this.selectDeptId.push(this.dataTableDept[i].id);
          this.multipleDeptSelection.push(this.dataTableDept[i]);
        }
      }
      this.deptSelectedAll = true;
      this.isDeptIndeterminate = false;
    } else {
      // 全不选
      this.selectDeptId = [];
      this.multipleDeptSelection = [];
    }
  }
  private deptSelection(item:any) {
    let select:any = this.selectDeptId.filter((id:any) => {
      return id === item.id;
    });
    if (select && select.length > 0) {
      this.multipleDeptSelection.push(item);
    } else {
      for (let i = 0; i < this.multipleDeptSelection.length; i++) {
        if (this.multipleDeptSelection[i].id === item.id) {
          this.multipleDeptSelection.splice(i, 1);
          break;
        }
      }
    }
    if (this.selectDeptId.length === this.dataTableDept.length) {
      this.deptSelectedAll = true;
      this.isDeptIndeterminate = false;
    } else if (this.selectUserId.length === 0) {
      this.deptSelectedAll = false;
      this.isDeptIndeterminate = false;
    } else {
      this.deptSelectedAll = false;
      this.isDeptIndeterminate = true;
    }
  }
  private tagDeptClose(val: any) {
    this.multipleDeptSelection.splice(
      this.multipleDeptSelection.indexOf(val),
      1
    );
    this.selectDeptId.splice(
      this.selectDeptId.indexOf(val.id),
      1
    );
    if (this.selectDeptId.length === this.dataTableDept.length) {
      this.deptSelectedAll = true;
      this.isDeptIndeterminate = false;
    } else if (this.selectUserId.length === 0) {
      this.deptSelectedAll = false;
      this.isDeptIndeterminate = false;
    } else {
      this.deptSelectedAll = false;
      this.isDeptIndeterminate = true;
    }
  }

  private userMoreClick() {
    this.userPage++;
    this.getUserList();
  }

  private serchUser() {
    this.userPage = 1;
    this.getUserList();
  }

  private cleanSerchUser() {
    this.formDeptStaff = { name: '', phone: '' };
    this.userPage = 1;
    this.getUserList();
  }
  private tagUserClose(val: any) {
    this.multipleUserSelection.splice(
      this.multipleUserSelection.indexOf(val),
      1
    );
    this.selectUserId.splice(
      this.selectUserId.indexOf(val.id),
      1
    );
    if (this.selectUserId.length === this.dataTableStaff.length) {
      this.userSelectedAll = true;
      this.isIndeterminate = false;
    } else if (this.selectUserId.length === 0) {
      this.userSelectedAll = false;
      this.isIndeterminate = false;
    } else {
      this.userSelectedAll = false;
      this.isIndeterminate = true;
    }
  }
  private SelectedAll() {
    if (this.userSelectedAll) {
      // 全选
      for (let i = 0; i < this.dataTableStaff.length; i++) {
        let index = this.selectUserId.indexOf(this.dataTableStaff[i].id);
        if (index === -1) {
          this.selectUserId.push(this.dataTableStaff[i].id);
          this.multipleUserSelection.push(this.dataTableStaff[i]);
        }
      }
      this.userSelectedAll = true;
      this.isIndeterminate = false;
    } else {
      // 全不选
      this.selectUserId = [];
      this.multipleUserSelection = [];
    }
  }
  private userSelection(item:any) {
    let select:any = this.selectUserId.filter((id:any) => {
      return id === item.id;
    });
    if (select && select.length > 0) {
      this.multipleUserSelection.push(item);
    } else {
      for (let i = 0; i < this.multipleUserSelection.length; i++) {
        if (this.multipleUserSelection[i].id === item.id) {
          this.multipleUserSelection.splice(i, 1);
          break;
        }
      }
    }
    if (this.selectUserId.length === this.dataTableStaff.length) {
      this.userSelectedAll = true;
      this.isIndeterminate = false;
    } else if (this.selectUserId.length === 0) {
      this.userSelectedAll = false;
      this.isIndeterminate = false;
    } else {
      this.userSelectedAll = false;
      this.isIndeterminate = true;
    }
  }
  private getUserList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      username: this.formDeptStaff.name,
      mobile: this.formDeptStaff.phone,
      size: 10,
      page: this.userPage
    };
    getWithAuthority(params)
      .then((res) => {
        if (res.data) {
          if (this.userPage === 1) {
            this.dataTableStaff = res.data.list;
          } else {
            this.dataTableStaff = this.dataTableStaff.concat(...res.data.list);
          }
          if (this.userPage < res.data.page_count) {
            this.userMore = true;
          } else {
            this.userMore = false;
          }
          let that = this;
          this.$nextTick(function() {
            if (that.multipleUserSelection && that.multipleUserSelection.length > 0) {
              that.multipleUserSelection.forEach((ser:any) => {
                let have:any = [];
                if (that.dataTableStaff) {
                  have = that.dataTableStaff.filter((v:any) => {
                    return v.id === ser.id;
                  });
                }
                if (have && have.length > 0) {
                  that.selectUserId.push(have[0].id);
                }
              });
            }
          });
        } else {
          this.dataTableStaff = [];
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.dataTableStaff = [];
        this.userPage = 1;
      });
  }

  private prevStep() {
    if (this.active === 2) {
      this.active = 1
    } else {
      this.active = 0
    }
  }
  private nextStep() {
    if (this.pushId) { // 如果是编辑需要赋值
      this.editData = this.editorData
    }
    if (this.active === 0) {
      (this.$refs.formName as any).validate((valid: any) => {
        if (valid) {
          this.active = 1;
          if (this.isDefaultGroup === '1') {
            if (this.editData && this.editData.push_type) {
              if (parseInt(this.editData.push_type) === 11) {
                this.radioDeptStaff = '11'; // 人员
                this.multipleUserSelection = this.editData.userList;
                this.multipleDeptSelection = [];
              } else {
                this.radioDeptStaff = '10'; // 部门
                this.multipleDeptSelection = this.editData.deptList;
                this.multipleUserSelection = [];
              }
            }
            this.deptPage = 1;
            this.userPage = 1;
            this.getUserList();
            this.getDepartmentList();
          } else {
            this.customerVisible = true;
          }
        } else {
          return false;
        }
      });
    } else {
      this.active = 2;
    }
  }
  private confirmHandle() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      group_name: this.editorData.group_name,
      group_type: '1',
      is_default_group: this.isDefaultGroup // parseInt(params.is_default_group) === 1 新建查看所有客户群组
    };

    let customers:any = [];
    this.selectCusromer.forEach((element:any) => {
      let customer:any = {};
      customer.user_id = element.customer_user_id;
      customer.user_name = element.name;
      customer.company_id = element.customer_company_id;
      customer.company_name = element.name;
      customer.type = element.customer_type;
      customers.push(customer);
    });
    params.customer = JSON.stringify(customers);
    // 报修维修类型 10服务部门推送 11维修工程师推送

    if (parseInt(this.radioDeptStaff) === 10) {
      if (!this.multipleDeptSelection || this.multipleDeptSelection.length < 1) {
        this.showErrorMsg(' 请选择部门')
        return
      }

      // 部门
      let depts:any = [];
      this.multipleDeptSelection.forEach((element:any) => {
        if (element.dept_id) {
          let dept:any = {};
          dept.id = element.dept_id;
          dept.name = element.name;
          depts.push(dept);
        } else {
          let dept:any = {};
          dept.id = element.id;
          dept.name = element.name;
          depts.push(dept);
        }
      });
      params.push_type = '10';
      params.servicer_department = JSON.stringify(depts);
    } else {
      if (!this.multipleUserSelection || this.multipleUserSelection.length < 1) {
        this.showErrorMsg(' 请选择人员')
        return
      }

      // 人员
      let users:any = [];
      this.multipleUserSelection.forEach((element:any) => {
        let user:any = {};
        user.user_id = element.id;
        user.user_name = element.name;
        users.push(user);
      });
      params.push_type = '11';
      params.engineer_user = JSON.stringify(users);
    }

    if (this.editData && this.editData.id) {
      params.group_id = this.editData.id;
      this.edit(params);
    } else {
      this.add(params);
    }
  }
  private add(params: any) {
    addGroupCs(params)
      .then((res) => {
        this.customerVisible = false;
        // this.dialogSelectDeptStaffVisible = false;
        this.showSuccessMsg('添加成功');
        this.close();
        this.$emit('selectedGroup');
        // this.getAuthGroup();
      })
      .catch((err) => {
        this.showErrorMsg(err);
      });
  }
  private edit(params:any) {
    editGroupCs(params)
      .then((res) => {
        this.customerVisible = false;
        // this.dialogSelectDeptStaffVisible = false;
        this.showSuccessMsg('修改成功');
        this.close();
        this.$emit('selectedGroup');
        // this.getAuthGroup();
      })
      .catch((err) => {
        this.showErrorMsg(err);
      });
  }

  private close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
